<template>
<div class="l-header">
  <router-link to="/">
    <h1 class="l-header__title">Works Thumbnail Generator</h1>
  </router-link>
  <div class="l-header__menu">
    <a class="c-text__link" href="https://forms.gle/qZrShWV7yaoodZS9A" target="_blank" rel="noopener">お問い合わせ</a>
    <TextLink href="/term" text="利用規約"></TextLink>
  </div>
</div>
</template>

<script>
import TextLink from '@/components/atoms/TextLink'

export default {
  components: {
    TextLink
  }
}
</script>

<style lang="scss" scoped>
.l-header{
  width: 98%;
  height: 60px;
  padding: 0 50/1280*100vw 0;
  background: #fff;
  border-radius: 60px;
  box-sizing: border-box;
  box-shadow: $bs-default;
  position: fixed;
  top: 30px;
  left: 1%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;

  &__title{
    font-size: 2.4rem;
    line-height: 2.4rem;
    @include media-queries-sp {
    font-size: 16/375*100vw;
    line-height: 16/375*100vw;
    }
  }

  &__menu {
    @include media-queries-sp {
      height: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      > * {
        font-size: 12/375*100vw;
        line-height: 12/375*100vw;
        text-align: right;
      }
    }
  }
}
</style>
